// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_fortawesome_react-fontawesome_index_es_js-node_modules_mui_material_Acco-6f466a":"76a616798be2fa349994","app":"e7aecc814f72bc44bcda","d3-array":"d040f00dcc71679c34d2","turf":"a715949e9bca33c211b6"}[chunkId] + ".js";
};